"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
// A button that is styled to appear as a link...
function ButtonLink({ children, className = 'link-primary', disabled = false, ...rest }) {
    return ((0, jsx_runtime_1.jsx)("button", { className: className, ...rest, disabled: disabled, children: children }));
}
exports.default = (0, react_1.memo)(ButtonLink);
